import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class LicenseGenerationSettingsService {
  constructor(private http: HttpClient) {}

  public fetchLicenseGenerationSettings(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_LICENSE_GENERATION`
    return this.http.get(url, {})
  }

  public updateLicenseGenerationSettings(payload: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_LICENSE_GENERATION`
    return this.http.put(url, payload)
  }
}
